export  class MarketStruct {
    category=""
    marketList=[]
}

